import App from './app';

import '@/styles/index.scss';
import React from 'react';
import gio from 'gio-webjs-sdk/gdp-full';

import ReactDOM from 'react-dom/client';
// gdp('init', 'your accountId', 'wx0d49f13c58d73131', {
//   version: 'your website version',
//   // OP私有部署客户请填写serverUrl，Saas客户请忽略
//   serverUrl: 'your server url',
//   ...other settings
// });
// !function(e,t,n,g,i){e[i]=e[i]||function(){(e[i].q=e[i].q||[]).push(arguments)},n=t.createElement("script"),tag=t.getElementsByTagName("script")[0],n.async=1,n.src=('https:'==document.location.protocol?'https://':'http://')+g,tag.parentNode.insertBefore(n,tag)}(window,document,"script","assets.giocdn.com/2.1/gio.js","gio");
//   gio('init', 'wx0d49f13c58d73131', {});
//   //custom page code begin here
//   //custom page code end here​
//   gio('send');

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
